module.exports = __webpack_public_path__ + "static/media/207-Kuchen_ID_16.0e772250.mp3";